import type { MetaTypeKey as MetaTypeKeyContract } from "../../contracts/utils/metadata/MetaTypeKey";

export class MetaTypeKey<T> implements MetaTypeKeyContract<T> {
	public readonly _dummy: T | null;
	constructor(public readonly path: string) {
		this._dummy = null;
	}

	isArrayType(): boolean {
		return this.path.endsWith("[]");
	}

	getMetaDataPath(): string {
		return this.path.replace(/\[\]$/, "");
	}
}
